import { learningContents } from '@/mocks/essentialCourseData';
import { useTranslation } from 'react-i18next';

const imageUrls: Record<string, string> = {
  'learning-manners': '/images/generated/essential-manners-2026.jpg',
  'learning-housekeeping': '/images/generated/essential-housekeeping-female-2026.jpg',
  'learning-table': '/images/generated/essential-napkin-2026.jpg',
  'learning-tea': '/images/generated/essential-tea-female-2026.jpg',
  'learning-ironing': '/images/generated/essential-ironing-2026.jpg',
  'learning-communication': '/images/generated/essential-writing-2026.jpg',
};

export default function LearningContent() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-16">
          {String(t('coursesEssential.learning.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesEssential.learning.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {String(t('coursesEssential.learning.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] max-w-xl mx-auto leading-relaxed">{__s}</p>))}
        </div>

        {/* Zigzag Content */}
        <div className="space-y-16 md:space-y-24">
          {learningContents.map((item, index) => {
            const isEven = index % 2 === 0;
            const title = t(`coursesEssential.learning.${index}.title`);
            const titleEn = t(`coursesEssential.learning.${index}.titleEn`);
            const description = t(`coursesEssential.learning.${index}.description`);
            return (
              <div
                key={item.id}
                className={`flex flex-col ${isEven ? 'md:flex-row' : 'md:flex-row-reverse'} gap-8 md:gap-12 items-center`}
              >
                {/* Image Side */}
                <div className="w-full md:w-1/2">
                  <div className="overflow-hidden">
                    <img
                      src={imageUrls[item.imageSeq]}
                      alt={t('coursesEssential.learning.imgAlt').replace('{title}', title)}
                      title={t('coursesEssential.learning.imgTitle').replace('{title}', title)}
                      className="w-full object-cover object-top transition-transform duration-700 hover:scale-105"
                    />
                  </div>
                  <div className="mt-3 h-[1px] bg-gradient-to-r from-transparent via-accent-500/20 to-transparent"></div>
                </div>

                {/* Text Side */}
                <div className="w-full md:w-1/2">
                  <div className="flex items-center gap-4 mb-4">
                    <span className="w-10 h-10 flex items-center justify-center">
                      <i className={`${item.icon} text-accent-600 text-xl`}></i>
                    </span>
                    <div>
                      <p className="text-[12px] text-accent-500/70 tracking-[0.15em] font-label mb-1">
                        {titleEn.toUpperCase()}
                      </p>
                      <h3 className="font-heading text-lg text-foreground-900 tracking-[0.06em]">
                        {title}
                      </h3>
                    </div>
                  </div>
                  <p className="text-[16px] text-foreground-700 leading-relaxed tracking-[0.03em]">
                    {description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}